import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const bmcHelix = defineConnector({
  identifier: "bmcHelix",
  name: "BMC Helix",
  tagLine: "IT service management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ serverUrl }) => domainToRegex(serverUrl),
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiToken,
        scheme: "AR-JWT",
      },
    ]),
  steps: [
    {
      title: "Get your BMC Helix API credentials",
      items: [
        {
          kind: "markdown",
          content: `1. In BMC Helix, go to **Administration › API Keys**
2. Create a new API key
3. Copy the key`,
        },
      ],
    },
    {
      title: "Enter your BMC Helix details",
      items: [
        {
          kind: "baseUrl",
          label: "Server URL",
          required: true,
          placeholder: "https://helix.example.com",
          target: { kind: "configuration", field: "serverUrl" },
          helperText: "The base URL of your BMC Helix instance.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ serverUrl }) =>
      `${serverUrl}/api/arsys/v1/entry/HPD:Help Desk?limit=1`,
  },
});
